var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0",attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"chart_style ma-0 pa-0",attrs:{"cols":"12"}},[_c('v-chart',{key:_vm.chart_key,ref:_vm.chart_ref,staticClass:"chart",attrs:{"id":_vm.chart_id,"option":_vm.option,"autoresize":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }